import { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { InputStyle, Wrapper } from './styles';

interface SearchInputProps {
  callback(search: string | string[]): void;
  loading?: boolean;
  value?: string | string[];
}

const SearchInput: React.FC<SearchInputProps> = ({ callback, loading, value }) => {
  const [search, setSearch] = useState<string | string[]>(value || '');

  const onEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        callback(search);
      }
    },
    [search]
  );

  return (
    <Wrapper>
      <InputStyle
        placeholder="Pesquisar"
        onKeyDown={onEnter}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <FontAwesomeIcon
          icon={faSearch}
          onClick={() => {
            callback(search);
          }}
        />
      )}
    </Wrapper>
  );
};

export default SearchInput;
